import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { forkJoin, of, Observable } from 'rxjs';
import { RoutingService } from '@app/core/services/routing.service';
import { JournalMainService, NB_ARTICLES_PER_PAGE } from '../journal-main.service';
import { Logger } from '@app/core/logging/logger.service';

@Injectable({
  providedIn: 'root'
})
export class JournalMainResolver implements Resolve<any> {
  public categoryUri: string;

  constructor(
    private routingService: RoutingService,
    private journalMainService: JournalMainService,
    private logger: Logger
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const nbEditoToDisplay = NB_ARTICLES_PER_PAGE;
    this.categoryUri = this.getCategoryInPath(route);
    let nbTotalArticles = new Observable();
    let pageNb = 1;
    if (state.url) {
      const pageSegment = state.url.split('/').find(index => index.includes('p-'));
      pageNb = pageSegment ? parseInt(pageSegment.substr(2), 10) : 1;
    }

    return forkJoin(
      this.journalMainService.getCategories().pipe(
        map(res => {
          return { list: res, current: res.find(cat => cat.uri === this.categoryUri) };
        }),
        catchError(error => {
          this.logger.debug(error.message, error);
          return of(null);
        })
      ),
      this.journalMainService.getEditos(nbEditoToDisplay, pageNb, this.categoryUri).pipe(
        map(res => {
          if (res.meta && res.meta.count) {
            nbTotalArticles = res.meta.count;
          }
          return { editoList: res.data.editoList, count: nbTotalArticles, pageNb, path: state.url };
        }),
        catchError(error => {
          this.logger.debug('[Journal Main] resolver' + error.message + ': catchError', error);
          return of(null);
        })
      )
    );
  }

  getCategoryInPath(route: ActivatedRouteSnapshot) {
    let categoryUri = '';
    if (route.url.length > 1 && route.url[1].path === 'cat') {
      categoryUri = route.url[2].toString();
    }
    return categoryUri;
  }
}
